<template>
  <div class="update-student-group-order-no">
    <el-popover
      placement="top"
      width="180"
      v-model="visible">
      <el-form ref="form" label-width="70px">
        <el-form-item label="顺序号：">
          <el-input v-model="interviewGroupOrderNo" size="mini" type="number" min="1"
                    @keydown.esc.native="visible = false" @keydown.enter.native="updateOrderNo"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="updateOrderNo" :loading="loading">确定</el-button>
      </div>
      <span slot="reference" class="data">{{$attrs['cell-value']}}
        <span class="icon"><i class="el-icon-edit"></i></span>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'UpdateStudentGroupOrderNo',
  data () {
    return {
      visible: false,
      interviewGroupOrderNo: null,
      loading: false
    }
  },
  created () {
    this.interviewGroupOrderNo = this.$attrs['cell-value']
  },
  activated () {
    this.interviewGroupOrderNo = this.$attrs['cell-value']
  },
  methods: {
    updateOrderNo () {
      if (!this.interviewGroupOrderNo) {
        this.$message.warning('请先输入顺序号')
        return false
      }
      // 正整数
      const r = /^\+?[1-9][0-9]*$/
      if (!r.test(this.interviewGroupOrderNo)) {
        this.$message.warning('顺序号请输入正整数')
        return false
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/interview/groupedStudent/updateOrderNo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.$attrs['row-data'].id,
          interviewGroupOrderNo: this.interviewGroupOrderNo
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('reloadGridData')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '修改失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.update-student-group-order-no {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  .data{
    .icon{
      margin-left: 5px;
    }
  }
}
</style>
